import { useEffect, useState } from 'react';
import { API_ENDPOINTS } from '../../common';

export function ManageResultats(interaction) {
    const [resultatsVote, setResults] = useState([]);
    const fetchResults = async () => {
        if (!interaction.id || !interaction.show_results) {
            setResults([]);
            return;
        }
        try {
            const response = await fetch(API_ENDPOINTS.VoteResults(interaction.id), {
                method: 'GET',
            });

            if (!response.ok) {
                console.error('Erreur lors de la récupération des résultats de vote, !response.ok');
                throw new Error('Erreur lors de la récupération des résultats de vote');
            }

            const data = await response.json();
            setResults(data);
        } catch (error) {
            console.error('Erreur lors de la récupération des résultats de vote :', error.message);
            setResults([]);
        }
    };

    return {
        resultatsVote,
        fetchResults,
    };
};
